import { checkEnviromentDependentString, validateUrl } from './Helper';
/**
 * インフィードを登録するフォーム
 */
var EditInfeedFormModel = /** @class */ (function () {
    function EditInfeedFormModel(_a) {
        var creativeFolderId = _a.creativeFolderId, _b = _a.name, name = _b === void 0 ? '' : _b, _c = _a.title, title = _c === void 0 ? '' : _c, _d = _a.description, description = _d === void 0 ? '' : _d, _e = _a.sponsoredBy, sponsoredBy = _e === void 0 ? '' : _e, _f = _a.ctaTemplateId, ctaTemplateId = _f === void 0 ? null : _f, _g = _a.iconImageAssetId, iconImageAssetId = _g === void 0 ? null : _g, _h = _a.mainImageAssetId, mainImageAssetId = _h === void 0 ? null : _h, _j = _a.landingPageUrl, landingPageUrl = _j === void 0 ? '' : _j;
        this.name = name;
        this.title = title;
        this.description = description;
        this.sponsoredBy = sponsoredBy;
        this.creativeFolderId = creativeFolderId;
        this.iconImageAssetId = iconImageAssetId;
        this.mainImageAssetId = mainImageAssetId;
        this.ctaTemplateId = ctaTemplateId;
        this.landingPageUrl = landingPageUrl;
    }
    Object.defineProperty(EditInfeedFormModel.prototype, "isValid", {
        get: function () {
            return (this.name.length > 0 &&
                this.isValidCreativeTitle &&
                checkEnviromentDependentString(this.title) &&
                this.isValidCreativeDescription &&
                checkEnviromentDependentString(this.description) &&
                this.iconImageAssetId !== null &&
                this.mainImageAssetId !== null &&
                this.isValidSponsoredBy &&
                checkEnviromentDependentString(this.sponsoredBy) &&
                this.ctaTemplateId !== null &&
                this.isValidLandingPageUrl);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EditInfeedFormModel.prototype, "isValidSponsoredBy", {
        get: function () {
            return (this.sponsoredBy.length > 0 &&
                this.sponsoredBy.length <=
                    EditInfeedFormModel.CREATIVE_SPONSORED_BY_MAX_LENGTH);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EditInfeedFormModel.prototype, "isValidCreativeTitle", {
        get: function () {
            return (EditInfeedFormModel.CREATIVE_TITLE_MIN_LENGTH <= this.title.length &&
                this.title.length <= EditInfeedFormModel.CREATIVE_TITLE_MAX_LENGTH);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EditInfeedFormModel.prototype, "isValidCreativeDescription", {
        get: function () {
            return (EditInfeedFormModel.CREATIVE_DESCRIPTION_MIN_LENGTH <=
                this.description.length &&
                this.description.length <=
                    EditInfeedFormModel.CREATIVE_DESCRIPTION_MAX_LENGTH);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EditInfeedFormModel.prototype, "isValidLandingPageUrl", {
        get: function () {
            return this.landingPageUrl.length !== 0 && validateUrl(this.landingPageUrl);
        },
        enumerable: false,
        configurable: true
    });
    EditInfeedFormModel.CREATIVE_TITLE_MIN_LENGTH = 1;
    EditInfeedFormModel.CREATIVE_TITLE_MAX_LENGTH = 25;
    EditInfeedFormModel.CREATIVE_DESCRIPTION_MIN_LENGTH = 10;
    EditInfeedFormModel.CREATIVE_DESCRIPTION_MAX_LENGTH = 90;
    EditInfeedFormModel.CREATIVE_SPONSORED_BY_MAX_LENGTH = 11;
    return EditInfeedFormModel;
}());
export { EditInfeedFormModel };
